import { useTranslation } from 'react-i18next';
import { InputSchema } from '@/features/agents';
import { useFeatureAgent } from '@/entities/agent';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { useParams } from 'react-router';

import type { AgentWithInputSchema } from './AgentDetail.types';

export const AgentDetail = () => {
  const { t } = useTranslation();
  const { t: tAdmin } = useTranslation('admin');
  const { agentId } = useParams<{ agentId: string }>();
  // Because entities don't value-import sibling entities, the page resolves
  // workspaceId here and passes it into the entity hook.
  const workspaceId = useCurrentWorkspaceId();
  const { agent, isLoading } = useFeatureAgent(agentId, workspaceId);

  if (isLoading) {
    return <div>{t('loading')}</div>;
  }

  if (!agent) {
    return <div>{tAdmin('agent.agentDetail.agentNotFound')}</div>;
  }

  // Cast to the extended type to access inputSchema safely
  const agentWithSchema = agent as AgentWithInputSchema;
  const inputSchema = agentWithSchema.inputSchema;

  return (
    <div className="flex flex-col gap-4 overflow-y-auto h-full">
      <h1 className="text-2xl font-bold text-foreground">{agent.title}</h1>
      <p className="text-sm text-foreground">{agent.description}</p>
      {inputSchema && <InputSchema schema={inputSchema} />}
    </div>
  );
};
